/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { ApiErrorDTO, ApiErrorMessageDTO } from '@api/models';
export class ApiErrorDecoder {
  protected error: ApiErrorDTO;

  protected defaultMessage: string;

  constructor(error: ApiErrorDTO, defaultMessage: string) {
    this.error = this.parseError(error);
    this.defaultMessage = defaultMessage;
  }

  /**
   * restituisce il messaggio di errore
   */
  getErrorMessage(): string {
    const relevantMessage = this.getRelevantMessage();
    const message = relevantMessage && relevantMessage.message;

    if (
      typeof message === 'string' &&
      message.toUpperCase() !== 'GENERIC_ERROR'
    ) {
      return message;
    } else if (typeof this.defaultMessage === 'string') {
      return this.defaultMessage;
    } else {
      return 'Error';
    }
  }

  /**
   * restituisce l'id parziale di errore
   */
  getErrorPartialUuid(): string {
    const uuid = this.getErrorUuid();

    if (typeof uuid === 'string' && uuid.indexOf('-') > -1) {
      return uuid.substring(0, uuid.indexOf('-'));
    } else {
      return uuid;
    }
  }

  /**
   * restituisce l'id dell'errore
   */
  getErrorUuid(): string {
    const relevantMessage = this.getRelevantMessage();

    return (relevantMessage && relevantMessage.uuid) || '0';
  }

  /**
   * restituisce il messaggio rilevante
   */
  getRelevantMessage(): ApiErrorMessageDTO {
    return this.findMessage(0);
  }

  /**
   * trova i messaggio corrispondente all'index
   */
  protected findMessage(index: number): ApiErrorMessageDTO {
    return this.error && this.error.messages && this.error.messages[index];
  }

  /**
   * decodifica l'errore
   */
  protected parseError(error: any): ApiErrorDTO {
    if (typeof error !== 'string' && !!error && typeof error === 'object') {
      return error;
    }

    try {
      error = JSON.parse(error);
    } catch (_) {
      error = {};
    }

    return error;
  }
}
